export const AVATAR_SIZE = {
  XXS: 'xxs',
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
} as const;

export type AvatarSize = (typeof AVATAR_SIZE)[keyof typeof AVATAR_SIZE];

export const AVATAR_VARIANT = {
  DEFAULT: 'default',
  RED: 'red',
  YELLOW: 'yellow',
  GREEN: 'green',
  ORANGE: 'orange',
  BLUE: 'blue',
  PINK: 'pink',
  SLATE: 'slate',
  GRAY: 'gray',
  ZINC: 'zinc',
  AMBER: 'amber',
  LIME: 'lime',
  EMERALD: 'emerald',
  TEAL: 'teal',
  CYAN: 'cyan',
  SKY: 'sky',
  INDIGO: 'indigo',
  VIOLET: 'violet',
  PURPLE: 'purple',
  FUCHSIA: 'fuchsia',
  ROSE: 'rose',
} as const;

export type AvatarVariant =
  (typeof AVATAR_VARIANT)[keyof typeof AVATAR_VARIANT];
